/**
 * Encode a value for url
 */
export const uriEncode = (value: string | number | null | undefined | boolean) => {
    if (!value) {
        return '';
    }
    return encodeURIComponent(value);
}
